<article class="history">
  <header class="history__intro">
    <p class="history__organization">{{ 'ABOUT-US_HISTORY-ORGANIZATION' | translate }}</p>
    <p class="history__top-credit">{{ 'ABOUT-US_HISTORY-TOP-PHOTO-CREDIT' | translate }}</p>
    <h2>{{ 'ABOUT-US_HISTORY-FOUNDER-HEADING' | translate }}</h2>
  </header>

  <section class="history__story" [attr.aria-label]="'ABOUT-US_HISTORY-FOUNDER-HEADING' | translate">
    <div class="history__founder-row">
      <div class="history__copy history__copy--opening">
        <p>{{ 'ABOUT-US_HISTORY-FOUNDER-PARAGRAPH-1' | translate }}</p>
        <p>{{ 'ABOUT-US_HISTORY-FOUNDER-PARAGRAPH-2' | translate }}</p>
        <p>{{ 'ABOUT-US_HISTORY-FOUNDER-PARAGRAPH-3' | translate }}</p>
      </div>

      <figure class="history__figure history__figure--katrina">
        <div class="history__image-frame">
          <img
            src="assets/images/about-us/hurricane-katrina-aftermath.jpg"
            [alt]="'ABOUT-US_HISTORY-KATRINA-ALT' | translate"
          />
        </div>
        <figcaption>{{ 'ABOUT-US_HISTORY-KATRINA-CREDIT' | translate }}</figcaption>
      </figure>
    </div>

    <div class="history__echoing-row">
      <img
        class="history__echoing-logo"
        src="assets/images/about-us/echoing-green-logo.png"
        [alt]="'ABOUT-US_HISTORY-ECHOING-GREEN-ALT' | translate"
      />
      <p>{{ 'ABOUT-US_HISTORY-ECHOING-GREEN-PARAGRAPH' | translate }}</p>
    </div>

    <div class="history__joel-row">
      <p>{{ 'ABOUT-US_HISTORY-JOEL-PARAGRAPH' | translate }}</p>
      <figure class="history__figure history__figure--joel">
        <div class="history__image-frame">
          <img src="assets/images/about-us/joel-muniz.jpg" [alt]="'ABOUT-US_HISTORY-JOEL-ALT' | translate" />
        </div>
        <figcaption>{{ 'ABOUT-US_HISTORY-JOEL-CREDIT' | translate }}</figcaption>
      </figure>
    </div>
  </section>

  <section class="history__website" aria-labelledby="history-website-heading">
    <h2 id="history-website-heading">{{ 'ABOUT-US_HISTORY-WEBSITE-HEADING' | translate }}</h2>
    <p>{{ 'ABOUT-US_HISTORY-LARGE-STATEMENT' | translate }}</p>
  </section>

  <section class="history__timeline" [attr.aria-label]="'ABOUT-US_HISTORY-TIMELINE-LABEL' | translate">
    <article
      class="history__timeline-entry"
      *ngFor="let entry of timelineEntries; let index = index; trackBy: trackByYear"
      [class.history__timeline-entry--right]="index % 2 === 1"
    >
      <div class="history__timeline-marker" aria-hidden="true"></div>
      <div class="history__timeline-year">{{ entry.year }}</div>
      <div class="history__timeline-card">
        <ul>
          <li *ngFor="let descriptionKey of entry.descriptionKeys; trackBy: trackByDescription">
            {{ descriptionKey | translate }}
          </li>
        </ul>
      </div>
    </article>
  </section>
</article>
